// extracted by mini-css-extract-plugin
module.exports = {"root":"FrontImage_root__2WVJ3","title":"FrontImage_title__2LL1j"};